import { render } from "./SentNftButton.vue?vue&type=template&id=6601e333&scoped=true"
import script from "./SentNftButton.vue?vue&type=script&lang=js"
export * from "./SentNftButton.vue?vue&type=script&lang=js"

import "./SentNftButton.vue?vue&type=style&index=0&id=6601e333&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6601e333"]])

export default __exports__